// Consent state persistence — single source of truth for what the user picked
// in the cookie banner. Lives in localStorage under `mori.consent`.
//
// Bumping CONSENT_VERSION re-prompts every user (existing stored state with a
// different version is treated as not-yet-decided). Bump it whenever the
// granular keys (ads / replay) change shape so we never silently apply an
// old decision to a new categorisation.

export const CONSENT_VERSION = 1 as const

const STORAGE_KEY = 'mori.consent'

export interface ConsentState {
  ads: boolean
  replay: boolean
  timestamp: number
  region: string
  version: typeof CONSENT_VERSION
}

export function loadConsent(): ConsentState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as ConsentState
    if (parsed.version !== CONSENT_VERSION) return null
    return parsed
  } catch {
    return null
  }
}

export function saveConsent(state: ConsentState): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state))
  } catch {
    // localStorage disabled / quota exceeded — nothing to do.
    // Banner will simply re-appear next session.
  }
}

export function clearConsent(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
